module.exports = __webpack_public_path__ + "static/media/delivery.1250d58e.svg";